
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dish-programming",
      function () {
        return require("private-next-pages/dish-programming.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dish-programming"])
      });
    }
  